import { truncateString } from "../../../utils/truncateString";

export default function Breadcrumb({ items }) {
  return (
    <nav aria-label="Breadcrumb">
      <ol role="list" className="mx-auto flex items-center space-x-2 font-semibold">
        {items.map((item, index) => (
          <li key={index} className={index === items.length - 1 ? 'text-sm' : ''}>
            <div className="flex items-center">
              <a href={item.href} aria-current={index === items.length - 1 ? 'page' : undefined}
                className={`capitalize mr-2 md:hidden text-sm ${index === items.length - 1 ? 'text-gray-500 hover:text-gray-600' : 'text-gray-900'}`}>
                {truncateString(item.label, 15)}
              </a>

              <a href={item.href} aria-current={index === items.length - 1 ? 'page' : undefined}
                className={`capitalize mr-2 max-md:hidden text-sm ${index === items.length - 1 ? 'text-gray-500 hover:text-gray-600' : 'text-gray-900'}`}>
                {item.label}
              </a>
              {index < items.length - 1 && (
                <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor" aria-hidden="true" className="h-5 w-4 text-gray-300">
                  <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                </svg>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}